import React from 'react';
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Destinations } from "@/components/Destinations";
import { Experience } from "@/components/Experience";
import { Reviews } from "@/components/Reviews";
import { ProofsSection } from "@/components/ProofsSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-secondary selection:text-primary">
      <Navbar />
      <main>
        <Hero />
        <Destinations />
        <Experience />
        <ProofsSection />
        <Reviews />
      </main>
      <Footer />
    </div>
  );
}
